import React = require("react");
import { AppContextValue, AppContextValueImp } from "./AppContextValue";

/**
 * AppContext Provider, warp AppContextValueImp and make it available in React Components
 */
export const AppContext = React.createContext<AppContextValue>(
  new AppContextValueImp()
);
